import { TypeNoteOption, EnumSideOptions } from "../../sharedTypes";

export interface IUltrasound {
    aorta: boolean;
    aorticAneurysm: boolean;
    abdomenComplete: boolean;
    carotidDoppler: boolean;
    gallbladderRUQ: boolean;
    shoulder: boolean;
    firstTrimesterOB: boolean;
    endovaginalIfIndicated: boolean;
    pelvis: TypePelvisOption;
    endovaginalOnly?: boolean;
    groin: Array<EnumSideOptions>;
    scrotumTesticular: boolean;
    softTissueMass: TypeNoteOption;
    thyroid: TypeThyroidOption;
    urinaryTract: EnumUrinaryOption;
    venousDopplerLowerExtremity: IDopplerExtremityOption;
    venousDopplerUpperExtremity: IDopplerExtremityOption;
    venousInsufficiency: boolean;
    other: TypeNoteOption;
}

type TypePelvisOption = {
    endoVaginal?: boolean;
} | boolean;

type TypeThyroidOption = {
    thyroidBiopsy?: boolean;
} | boolean;

export enum EnumUrinaryOption {
    KidneysAndBladder = "kidneys_and_bladder",
    BladderOnly = "bladder_only"
}

export interface IDopplerExtremityOption {
    left: boolean;
    right: boolean;
}

// Record for mapping urinary options to their descriptions
export const URINARY_OPTIONS: Record<EnumUrinaryOption, string> = {
    [EnumUrinaryOption.KidneysAndBladder]: 'Kidneys & Bladder',
    [EnumUrinaryOption.BladderOnly]: 'Bladder Only'
};
